import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(
    private titleService: Title, 
    private metaService: Meta,
    @Inject(DOCUMENT) private dom: Document,
    private router: Router
  ) { }

  updateSEO(data: { 
    titleTag: string; 
    nome: string; 
    metaDescription?: string; 
    tags: string[];
  }): void {
    // Atualiza o título da página
    this.titleService.setTitle(
      data.titleTag || data.nome || 'Faculdade Souza Marques - Faculdades de qualidade para todos.'
    );

    // Atualiza a meta tag description
    this.metaService.updateTag({
      name: 'description',
      content: data.metaDescription || 'FACULDADE SOUZA MARQUES: SUA MELHOR ESCOLHA É AQUI. - Cursos de Graduação, Pós-Graduação e Extensão nas modalidades EAD e Presencial.'
    });

    // Atualiza a meta tag keywords, se as tags forem fornecidas
    if (data.tags && data.tags.length) {
      this.metaService.updateTag({
        name: 'keywords',
        content: data.tags.join(', ')
      });
    }else{
      this.metaService.updateTag({
        name: 'keywords',
        content: 'FACULDADE SOUZA MARQUES'
      });
    }

    // Atualiza a tag canonical se a URL for fornecida
    this.updateCanonical();
    
  }

  private updateCanonical(): void {

    const url =  `${this.dom.location.origin}${this.router.url}`;
    
    // Busca a tag canonical existente
    let link: HTMLLinkElement = this.dom.querySelector("link[rel='canonical']");
    if (link) {
      // Se existir, atualiza o atributo href
      link.setAttribute('href', url);
    } else {
      // Caso não exista, cria a tag e adiciona ao head
      link = this.dom.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url);
      this.dom.head.appendChild(link);
    }
  }
}
